import { logWarning } from '../../../utils/log-utils'

const warned: Record<string, boolean> = {}
export default (valid: boolean, message: string) => {
  if (!valid && !warned[message]) {
    logWarning(message)
    warned[message] = true
  }
}
